// extracted by mini-css-extract-plugin
export default {"svgSubtype":"actosSubtype_svgSubtype__QHnwo","titleSub":"actosSubtype_titleSub__nR8P0"};